import * as _ from "lodash";
import request from "@/utils/request";
import base_ds from "@/services/base_datasource_service";
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import {AcceptChangeSchema, AcceptData, IYearAcceptResponseMap, IAcceptResponse} from "./models-service";
import notify_service from "@/services/notify_service";
import PresetService from '@/services/user_preset_service';
import { Watch } from "vue-property-decorator";
import Vue from "vue"; 

const route_ns = `accept`;

class AcceptService {

    data_source = base_ds.getBaseDataSource(route_ns);
    public crud = base_ds.getBaseCrud(route_ns);

    current: AcceptData | null;
    private acceptDict: IYearAcceptResponseMap = {};
    public filters_changed: boolean = false;
    public changed: boolean = false;
    public changes: any = {};
    public state = Vue.observable({
      acceptChanges: false
    });

  constructor() {
    //
  }


  async getAccepts(cut_id: string | null, months: any[] | null, obj_ids: number[] | null) {
    const payload = {
      months: months,
      obj_ids: obj_ids || undefined,
    }
    const response: AxiosResponse = await this.crud.post(cut_id, payload, 15000);
    if (response) {
      return response;
    } else {
      return null;
    }
  }

  async send_emails(emails: string[], text: string | null) {
    const payload = {
      emails: emails,
      text: text
    }
    try {
      const response: AxiosResponse = await request({
        url: `${route_ns}/send_email`,
        method: 'post',
        data: payload
      });

      if (response) {
        return response;
      } else {
        return null;
      }

    } catch (e) {
      notify_service.error('Ошибка отправки запроса рассылки уведомлений')
    }

  }

  setCurrent(value: AcceptData) {
    this.current = value;
  }

  public SetAcceptDict(val: IAcceptResponse, idYear: string) {
    this.acceptDict[idYear] = val;
  }

  public GetAcceptDict() {
    if (!PresetService.currentPreset?.id_year) return  {}
    return this.acceptDict[PresetService.currentPreset.id_year] || {}
  }

  public async save(cut_id: string | null, entity: AcceptChangeSchema) {
    const response: AxiosResponse = await this.crud.post(`${cut_id}/save`, entity, 10000);

    if (response && response.data) {
      return { data: true };
    } else {
      return true;
    }
  }

  public async getWithFilter(cuts: any) {
    const url = `${route_ns}`;

    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "post",
      data: cuts,
      timeout: 25000
    });

    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }


  empty() {

  }

}

export default new AcceptService();
